import { WFComponent } from "@xatom/core";
import { FavoritesAPI } from "../services/api/favorites";
import { favoritesStore } from "../stores/favoritesStore";

export class ComponentCardHandler {
  constructor() {
    this.init();
    this.observeDOMChanges();
  }

  private async init() {
    try {
      const response = await FavoritesAPI.getFavorites();
      const favoriteComponents = response.data.favorite_components || {};
      favoritesStore.setFavorites({
        favorite_components: favoriteComponents,
        favorite_inspirations: {},
      });

      const componentCards = document.querySelectorAll(
        '[ss-component-ele="card"]'
      );
      componentCards.forEach((cardElement) => {
        this.setupCard(cardElement);
      });
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  }

  private setupCard(cardElement: Element) {
    const $card = new WFComponent(cardElement as HTMLElement);
    const $favBtn = $card.getChildAsComponent('[fav-btn-class="is-fav"]');
    const slug = $card.getAttribute("ss-webflow-component");
    const favorites = favoritesStore.getFavoriteComponents();

    if (favorites[slug]) {
      $favBtn.addCssClass("is-fav");
    }

    if ($favBtn && !$favBtn.getElement().hasAttribute("data-listener-added")) {
      $favBtn.getElement().setAttribute("data-listener-added", "true");
      $favBtn.on("click", async () => {
        try {
          const isFavorite = $favBtn.getCssClass().includes("is-fav");

          if (!slug) {
            console.error("Slug not found");
            return;
          }

          const toggleResponse = await FavoritesAPI.toggleFavorite({
            slug,
            type: "component",
            isFavorite: !isFavorite,
          });

          if (toggleResponse.data.success) {
            if (toggleResponse.data.favorites[slug]) {
              $favBtn.addCssClass("is-fav");
              favoritesStore.updateFavorite(
                "component",
                slug,
                toggleResponse.data.favorites[slug]
              );
            } else {
              $favBtn.removeCssClass("is-fav");
              favoritesStore.updateFavorite("component", slug, null);
            }
          } else {
            console.error("Failed to toggle favorite");
          }
        } catch (error) {
          console.error("Error toggling favorite:", error);
        }
      });
    }
  }

  private observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const cardElement = node as HTMLElement;

              if (
                cardElement.matches('[ss-component-ele="card"]') ||
                cardElement.querySelector('[ss-component-ele="card"]')
              ) {
                const cardElementIn = cardElement.matches(
                  '[ss-component-ele="card"]'
                )
                  ? cardElement
                  : cardElement.querySelector('[ss-component-ele="card"]');
                this.setupCard(cardElementIn);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}
